import { HealthResponse } from '@squats/shared';
import { useEffect, useState } from 'react';
import { api } from '../api.ts';
import { useOfflineReady, useOnline } from '../hooks.ts';

type Health = { state: 'loading' } | { state: 'ok'; data: HealthResponse } | { state: 'error' };

export function StatusCard() {
  const online = useOnline();
  const offlineReady = useOfflineReady();
  const [health, setHealth] = useState<Health>({ state: 'loading' });

  useEffect(() => {
    if (!online) return;
    api('/api/health', HealthResponse)
      .then((data) => setHealth({ state: 'ok', data }))
      .catch(() => setHealth({ state: 'error' }));
  }, [online]);

  return (
    <section className="card" aria-labelledby="status-h">
      <h2 id="status-h">Status</h2>
      <dl className="facts">
        <dt>Connection</dt>
        <dd>
          <span className={online ? 'pill ok' : 'pill warn'}>{online ? 'Online' : 'Offline'}</span>
        </dd>
        <dt>Offline app</dt>
        <dd>
          <span className={offlineReady ? 'pill ok' : 'pill'}>{offlineReady ? 'Installed' : 'Installing…'}</span>
        </dd>
        <dt>API</dt>
        <dd>
          {health.state === 'loading' && <span className="pill">Checking…</span>}
          {health.state === 'ok' && <span className={health.data.ok ? 'pill ok' : 'pill warn'}>{health.data.ok ? 'Healthy' : 'Degraded'}</span>}
          {health.state === 'error' && <span className="pill warn">Unreachable</span>}
        </dd>
        <dt>Version</dt>
        <dd>
          <code>{__APP_VERSION__}</code>
        </dd>
      </dl>
    </section>
  );
}
